import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { usePopstate } from '@/hooks'
import styles from './index.module.less'
import MenuPopup from '@/components/MenuPopup'
import _logo from '@/assets/imgs/logo.svg'
import menu from '@/assets/icons/menu.svg'
import downloadCenter from '@/assets/icons/downloadCenter.svg'
import { useSelector } from '@/store'
import noticeCenter from '@/assets/icons/noticeCenter.svg'
import { Guide } from './components/Guide'
import { imgURL } from '@/utils/countryVersion'
import { ShowI18nKeyButton } from './components/ShowI18nKeyButton'
import { useMobileNotif } from '@/hooks/useNotification'

const logo = imgURL('./imgs/logo.png') || _logo

interface NavBarProps {
  routes?: any
}

const NavBar: React.FC<NavBarProps> = (props: NavBarProps) => {
  const { routes } = props
  const [visible, setVisible] = useState(false)
  const messageCount = useSelector((state) => state.home.unReadMessageCount)
  const downloadCount = useSelector((state) => state.home.unReadDownloadCount)

  const history = useHistory()
  const toNoticeCenter = () => {
    history.push('/home/noticeCenter')
  }
  const toDownloadCenter = () => {
    history.push('/home/downloadCenter')
  }

  useMobileNotif()
  usePopstate(() => {
    setVisible(false)
  })

  return (
    <div className={styles.navBar}>
      <div className={styles.leftBox}>
        <img src={menu} onClick={() => setVisible(true)} className={styles.menu} />
        <img src={logo} className={styles.logo} />
      </div>

      <div className={styles.rightBox}>
        <Guide />

        <ShowI18nKeyButton />
        <div className={styles.badge}>
          {messageCount > 0 ? <div className={styles.badgeNumber}>{messageCount > 99 ? '99+' : messageCount}</div> : ''}
          <img src={noticeCenter} className={styles.icon} onClick={toNoticeCenter} />
        </div>
        <div className={styles.badge}>
          {downloadCount > 0 ? <div className={styles.badgeNumber}>{downloadCount > 99 ? '99+' : downloadCount}</div> : ''}
          <img src={downloadCenter} id="parabola-export" className={styles.icon} onClick={toDownloadCenter} />
        </div>
      </div>
      <MenuPopup
        visible={visible}
        onMaskClick={() => {
          setVisible(false)
        }}
        routes={routes}
      ></MenuPopup>
    </div>
  )
}

export default NavBar
